import { render, staticRenderFns } from "./avareNumeric.vue?vue&type=template&id=588e71cc&"
import script from "./avareNumeric.vue?vue&type=script&lang=js&"
export * from "./avareNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports